/**
 * Set the max-height variable value for the container based on the target element.
 * @param container
 * @param target
 * @param applyChange
 * @param undoChange
 */
export function setMaxHeight(container, target, applyChange, undoChange) {
    const value = calcMaxHeight(target, applyChange, undoChange);
    container.style.setProperty('--max-height', `${value}px`);
}
/**
 * Calculate the target element's height when changes are applied.
 * @param element
 * @param applyChange
 * @param undoChange
 */
export function calcMaxHeight(element, applyChange, undoChange) {
    applyChange();
    const height = element.getBoundingClientRect().height;
    undoChange();
    return height;
}
